import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine Tailwind class names while resolving conflicts.
 *
 * @example
 *   cn('px-2 py-1', isActive && 'bg-kw-cerulean text-white', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
